import { render } from "./PopUp.vue?vue&type=template&id=71c7b988&scoped=true"
import script from "./PopUp.vue?vue&type=script&lang=js"
export * from "./PopUp.vue?vue&type=script&lang=js"

import "./PopUp.vue?vue&type=style&index=0&id=71c7b988&scoped=true&lang=scss"
import "./PopUp.vue?vue&type=style&index=1&id=71c7b988&lang=scss"

import exportComponent from "/Users/alexanderwesselburg/Projekte/MyPortal/fewo-in-ahrenshoop_v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71c7b988"]])

export default __exports__